module.exports = __webpack_public_path__ + "static/img/DC_Comics-Default.cb2e6ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/DC_Comics-Default.png
// module id = 1567
// module chunks = 0